/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Deceased_ClearInputs */



/**
* | output |
* | --- |
* | "Clear deceased status" |
*
* @param {Deceased_ClearInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const deceased_clear = /** @type {((inputs?: Deceased_ClearInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deceased_ClearInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Retirer le statut de décès")
	if (locale === "es") return /** @type {LocalizedString} */ ("Borrar estado de fallecimiento")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Remover status de falecimento")
	if (locale === "it") return /** @type {LocalizedString} */ ("Rimuovi lo stato di decesso")
	return /** @type {LocalizedString} */ ("Clear deceased status")
});